/**
 * Opt-in cache / sync diagnostics. Enable with:
 *   VITE_CACHE_DEBUG=true
 * or at runtime: window.__GYM_CACHE_DEBUG__ = true
 */
export function isCacheDebugEnabled() {
  if (typeof import.meta !== 'undefined' && import.meta.env?.VITE_CACHE_DEBUG === 'true') {
    return true;
  }
  if (typeof window !== 'undefined' && window.__GYM_CACHE_DEBUG__ === true) {
    return true;
  }
  return false;
}

export function cacheDebugLog(tag, payload) {
  if (!isCacheDebugEnabled()) return;
  // eslint-disable-next-line no-console
  console.log(`[CacheDebug:${tag}]`, payload ?? '');
}

/**
 * Subscribes to React Query cache + mutation events (high-signal only).
 */
export function installCacheDebugListeners(queryClient) {
  if (!isCacheDebugEnabled() || !queryClient) return () => {};

  const qc = queryClient.getQueryCache().subscribe((event) => {
    const q = event?.query;
    if (!q) return;
    const { queryKey, state } = q;
    if (event.type === 'updated' && state.fetchStatus === 'fetching') {
      cacheDebugLog('query-fetching', { queryKey, status: state.status });
    }
    if (event.type === 'updated' && state.isInvalidated) {
      cacheDebugLog('query-invalidated', { queryKey });
    }
  });

  const mc = queryClient.getMutationCache().subscribe((event) => {
    const m = event?.mutation;
    if (!m) return;
    if (event.type === 'updated' && m.state.status === 'success') {
      cacheDebugLog('mutation-success', {
        mutationKey: m.options.mutationKey,
        variables: m.state.variables,
      });
    }
  });

  return () => {
    qc();
    mc();
  };
}
